import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { environmentVariableAPI } from "../../utilities/api/environmentVariableApi";

interface EnvironmentState {
  values?: any;
}

const initialState: EnvironmentState = {
}

const environmentSlice = createSlice({
  name: 'environmentFiling',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getEnvironmentVariables.fulfilled, (state, action) => {
      state.values = action.payload;
    });
  },
});

export const getEnvironmentVariables = createAsyncThunk('stateEnvironment/getEnvironmentVariables', async (url: string) => {
  return await environmentVariableAPI.getEnvironmentVariables(url);
});

export default environmentSlice.reducer;